angular.element(document).ready(function () {
  angular.bootstrap(document, ['lmApp']);
});
